var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// components
import RegisterStep from "./components/RegisterStep";
import VerifyStep from "./components/VerifyStep";
import { AuthPagesWrapper } from "../LoginPage";
import { saveToLocalStorage, getFromLocalStorage, removeFromLocalStorage, } from "module/common/utils";
import { useSubmit } from "module/common/components/forms";
import { selectAuthErrorMessage } from "module/main/store/auth/selectors";
import { callPostAuthRegister, callPostAuthVerify } from "module/main/store/auth/thunk";
import { useAppDispatch } from "module/main/store/hooks";
import { useSelector } from "react-redux";
import { setResetAuthErrorMessage } from "module/main/store/auth/reducer";
import { getCookie, eraseCookie } from "module/main/util";
import { gtmPush } from "module/main/util";
var SS_UTM_DATA_COOKIE_NAME = "ss_utm_data";
var FIRST_ATTRIBUTION_KEY = "ss_utm_first_touch";
var getUtmDataFromCookie = function () {
    var utmData = decodeURIComponent(getCookie(SS_UTM_DATA_COOKIE_NAME) || "{}");
    var parsedUtmData = JSON.parse(utmData);
    if (Object.keys(parsedUtmData).length > 0)
        return parsedUtmData;
    return null;
};
var SignUp = function () {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _a = useState(0), currentStep = _a[0], setCurrentStep = _a[1];
    var _b = useState(null), utmData = _b[0], setUtmData = _b[1];
    var errorMessage = useSelector(selectAuthErrorMessage);
    var handleRegister = useSubmit(function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = __assign(__assign({}, request), { tos: request.tos === "on", 
                        // "on" means I agree to receive emails, so reverse
                        emailOptOut: request.emailOptOut !== "on", utmData: utmData });
                    return [4 /*yield*/, dispatch(callPostAuthRegister(payload))];
                case 1:
                    response = _a.sent();
                    if (response.payload === true) {
                        setCurrentStep(1);
                        gtmPush("signup_pre_email");
                        eraseCookie(SS_UTM_DATA_COOKIE_NAME);
                        removeFromLocalStorage(FIRST_ATTRIBUTION_KEY);
                    }
                    return [2 /*return*/];
            }
        });
    }); });
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var token = urlParams.get("token");
        if (token) {
            setCurrentStep(1);
            dispatch(callPostAuthVerify({ token: token || "" })).then(function (response) {
                if (response.payload === true)
                    navigate("/");
            });
        }
        var utmData = getUtmDataFromCookie();
        if (!utmData) {
            var utmSource = urlParams.get("utm_source");
            var utmMedium = urlParams.get("utm_medium");
            var utmCampaign = urlParams.get("utm_campaign");
            var utmContent = urlParams.get("utm_content");
            var utmTerm = urlParams.get("utm_term");
            if (utmSource || utmMedium || utmCampaign || utmContent || utmTerm)
                utmData = {
                    ss_utm_source: utmSource,
                    ss_utm_medium: utmMedium,
                    ss_utm_campaign: utmCampaign,
                    ss_utm_content: utmContent,
                    ss_utm_term: utmTerm,
                };
        }
        if (utmData) {
            var firstTouchData = getFromLocalStorage(FIRST_ATTRIBUTION_KEY, null);
            if (!firstTouchData) {
                var getFirstTouch = function (utmData) {
                    return Object.keys(utmData).reduce(function (acc, key) {
                        acc["".concat(key, "_first_touch")] = utmData[key];
                        return acc;
                    }, {});
                };
                firstTouchData = getFirstTouch(utmData);
                saveToLocalStorage(FIRST_ATTRIBUTION_KEY, firstTouchData);
            }
            setUtmData(__assign(__assign({}, utmData), firstTouchData));
        }
        // Set the HubSpot tracking cookie if it exists, regardless of UTM data
        var hutk = getCookie("hubspotutk");
        if (hutk)
            setUtmData(function (utmData) { return (__assign(__assign({}, utmData), { hutk: hutk })); });
    }, []);
    useEffect(function () {
        dispatch(setResetAuthErrorMessage());
    }, [currentStep]);
    var renderComponent = function (step) {
        switch (step) {
            case 0:
                return _jsx(RegisterStep, { handleRegister: handleRegister });
            case 1:
                return _jsx(VerifyStep, {});
            default:
                return _jsx(RegisterStep, { handleRegister: handleRegister });
        }
    };
    return (_jsxs(AuthPagesWrapper, { children: [renderComponent(currentStep), errorMessage ? _jsx("div", { className: "bg-danger/50 p-2 mt-2", children: errorMessage }) : null] }));
};
export default SignUp;
